import { j as l } from "./jsx-runtime-B6kdoens.js";
import V, { useRef as xe, useState as ae, forwardRef as yr, useImperativeHandle as Bt, useMemo as We, useEffect as ne } from "react";
import { S as Ot, c as O, j as G, C as xr, k as Pt, B as De, P as ct, l as Ve, g as mr, T as jt, o as br, u as pr, D as vr, b as _r, d as Fr, I as Cr, e as jr } from "./logo-svg-embed-Cp82pc6m.js";
import { FontAwesomeIcon as rt } from "@fortawesome/react-fontawesome";
import { O as Ke, H as Wt, B as Nr, A as Ar, C as Oe, b as Kt } from "./bottom-button-bar-CYbo6Fvi.js";
import "./product-utils-BZ9FKiCb.js";
import "@fortawesome/pro-regular-svg-icons";
import { a as Nt, u as wr } from "./virtual-scroll-DwBPDmEx.js";
import { roundToDecimals as qt, formatTime as Dr, truncateNumber as Sr } from "./index.utils.es.js";
import "@fortawesome/pro-solid-svg-icons";
class Gt {
  constructor(r, t) {
    this.column = r, this.sortDirection = t;
  }
}
const de = {
  BASIC: 0,
  CUSTOM: 1,
  LINK: 2,
  COUNT: 3,
  SELECTION: 5
};
function Ye({
  column: e,
  sortDirection: r,
  onSortClick: t,
  headerTriCheck: s,
  className: i
}) {
  var o;
  const n = xe(), c = function() {
    let f;
    r == G.DEFAULT ? f = G.ASCENDING : r == G.ASCENDING ? f = G.DESCENDING : r == G.DESCENDING && (f = G.DEFAULT), t(new Gt(e, f));
  };
  return /* @__PURE__ */ l.jsxs("div", { ref: n, className: O(i), role: "columnheader", children: [
    e.type == de.SELECTION && s,
    e.type != de.SELECTION && /* @__PURE__ */ l.jsxs(
      "button",
      {
        className: "data-table-header-column-text-container",
        onClick: () => e.options.sortingEnabled && c(),
        tabIndex: "0",
        "aria-label": "Sort the " + e.title + " Column",
        children: [
          /* @__PURE__ */ l.jsx("div", { className: "data-table-header-column-text", tabIndex: "-1", children: /* @__PURE__ */ l.jsx(Ke, { text: e.title, children: e.title }) }),
          ((o = e.options) == null ? void 0 : o.sortingEnabled) && /* @__PURE__ */ l.jsx(
            Ot,
            {
              column: e,
              sortDirection: r,
              tabIndex: "-1"
            }
          )
        ]
      }
    )
  ] });
}
class Er {
  constructor(r, t) {
    this.stateColumns = r, this.update = t;
  }
}
function At(e) {
  const r = e.map((n) => [n.id, G.DEFAULT]), [t, s] = ae({
    sortDirectionsMap: new Map(r)
  }), i = function(n) {
    const c = t.sortDirectionsMap;
    for (const o of c.keys())
      n.column.id != o ? c.set(o, G.DEFAULT) : c.set(o, n.sortDirection);
    s({ sortDirectionsMap: c });
  };
  return new Er(t, i);
}
function Vr({
  columns: e,
  onSortClick: r,
  keyPrefix: t,
  headerTriCheck: s,
  rowHeight: i,
  responsiveStyles: n,
  hasActionMenu: c,
  className: o
}) {
  const f = At(e), y = function(_) {
    f.update(_), r(_);
  }, h = e[0].type == de.SELECTION, g = h ? 1 : 0;
  return /* @__PURE__ */ l.jsxs("div", { className: "data-table-row-container", style: { height: i }, role: "row", children: [
    h && /* @__PURE__ */ l.jsx(
      Ye,
      {
        column: e[0],
        className: O(o, "data-table-selection-column"),
        headerTriCheck: s
      },
      t + "-checkbox-selection"
    ),
    e.map((_, $) => {
      if (_.type != de.SELECTION)
        return /* @__PURE__ */ l.jsx(
          "div",
          {
            className: O(
              `data-table-header-cell-container-${_.id}`,
              o,
              $ == g ? "data-table-cell-container-first" : "data-table-cell-container"
            ),
            children: /* @__PURE__ */ l.jsx(
              Ye,
              {
                column: _,
                onSortClick: y,
                sortDirection: f.stateColumns.sortDirectionsMap.get(
                  _.id
                ),
                className: O(
                  `data-table-header-cell-${_.id}`,
                  o,
                  $ == g ? "data-table-header data-table-cell-first" : "data-table-header data-table-cell"
                )
              },
              t + _.id
            )
          },
          t + "container" + _.id
        );
    }),
    n["large-panel"] && c && /* @__PURE__ */ l.jsx("div", { children: " " }, t + "actionmenu")
  ] });
}
function Pe({ children: e, style: r, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { style: r, className: O(t), role: "cell", children: e });
}
function ve({ value: e, overflowEnabled: r, tooltipText: t, className: s }) {
  const i = r ? /* @__PURE__ */ l.jsx(Ke, { text: t ?? e, children: e }) : e;
  return /* @__PURE__ */ l.jsx(Pe, { className: O(s), children: e ? i : /* @__PURE__ */ l.jsx(Wt, {}) });
}
function Tr({
  column: e,
  style: r,
  handleSelectChange: t,
  value: s,
  checked: i,
  isLocked: n,
  className: c = ""
}) {
  return /* @__PURE__ */ l.jsx(Pe, { column: e, style: r, className: O(c), children: /* @__PURE__ */ l.jsx(
    xr,
    {
      handleSelectChange: t,
      value: s,
      checked: i,
      isLocked: n
    }
  ) });
}
const kr = (e, r) => e["small-panel"] ? {
  gridRow: `auto / span ${r}`
} : e["medium-panel"] ? {
  gridRow: `auto / span ${Math.ceil(r / 2)}`
} : {}, Ir = yr(({ initialData: e }, r) => {
  const [t, s] = ae(e);
  return Bt(r, () => ({
    updateData: (i) => {
      s(i);
    }
  })), /* @__PURE__ */ l.jsx(l.Fragment, { children: t > 0 ? /* @__PURE__ */ l.jsx("div", { className: "badge-container", children: /* @__PURE__ */ l.jsx(Nr, { className: "badge", value: `${t} LIVE` }) }) : null });
});
function Hr({
  keyPrefix: e,
  rowData: r,
  columns: t,
  onSortClick: s,
  responsiveStyles: i = {},
  handleSelectChange: n,
  className: c,
  rowIndex: o,
  checked: f,
  keyFields: y,
  selectionColumnEnabled: h,
  actionMenuOptions: g,
  isRowLocked: _,
  isRowActive: $,
  isMenuActionVisible: L,
  liveDataRef: q
}) {
  const B = At(t), M = We(() => L ? L(r, g) : g, [L, g, r]), w = function(x) {
    B.update(x), s(x);
  }, T = h || t[0].type == de.SELECTION, D = kr(
    i,
    t.length
  ), m = (x) => $ ? $(x) : !0, C = i["medium-panel"] && T && t.length % 2 != 0, F = y.map((x) => {
    if (x in r)
      return r[x];
    throw `keyField ${x} not found in row data object. Properties of row data object include ${JSON.stringify(
      Object.keys(r)
    )}`;
  });
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    t.map((x, H) => {
      var he;
      if (x.type == de.SELECTION)
        return /* @__PURE__ */ l.jsx(
          Tr,
          {
            column: t[0],
            className: "data-table-selection-column",
            style: D,
            rowValues: F,
            id: r.id,
            handleSelectChange: n,
            checked: f,
            isLocked: _ ? _(r) : !1
          },
          e + "checkboxselection"
        );
      const U = e + "-" + x.id, Y = T ? 1 : 0, N = H == Y ? "data-table-cell-first" : "data-table-cell", E = O(
        c,
        N,
        `data-table-cell-${x.id}`
      ), k = r[x.propName];
      let P;
      if (x.type == de.BASIC)
        P = /* @__PURE__ */ l.jsx(
          ve,
          {
            value: k ?? "",
            className: E,
            overflowEnabled: x.options.overflowEnabled
          }
        );
      else if (x.type == de.COUNT)
        P = /* @__PURE__ */ l.jsx(
          ve,
          {
            className: E,
            value: k ? /* @__PURE__ */ l.jsx(Oe, { count: k }) : 0
          }
        );
      else if (x.type == de.LINK) {
        const Q = x.options.customFunction(k, r, o) ?? k;
        P = /* @__PURE__ */ l.jsx(
          ve,
          {
            value: Q,
            overflowEnabled: x.options.overflowEnabled,
            tooltipText: k,
            className: E
          }
        );
      } else if (x.type == de.CUSTOM) {
        const te = x.options.customFunction(
          k,
          r,
          o
        );
        P = /* @__PURE__ */ l.jsx(Pe, { className: E, children: te });
      }
      const I = H == Y, Z = (he = x.options) == null ? void 0 : he.isLiveDataColumn;
      return /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: O(
            `data-table-cell-container-${x.id}`,
            I ? "data-table-cell-container-first" : "data-table-cell-container",
            c
          ),
          children: [
            !i["large-panel"] && /* @__PURE__ */ l.jsx(
              Ye,
              {
                column: x,
                onSortClick: w,
                sortDirection: B.stateColumns.sortDirectionsMap.get(
                  x.id
                ),
                className: I ? "cell-level-header data-table-header-column-first" : "cell-level-header data-table-header-column"
              },
              "mobile" + x.id
            ),
            P,
            Z && /* @__PURE__ */ l.jsx(
              Ir,
              {
                ref: q,
                initialData: 0,
                rowData: r
              },
              `${e}-container-${U}`
            )
          ]
        },
        `${e}-container-${U}`
      );
    }),
    i["large-panel"] && m(r) && (M == null ? void 0 : M.length) > 0 && /* @__PURE__ */ l.jsx(
      Pe,
      {
        className: O("data-table-cell", "action-menu-cell", c),
        children: /* @__PURE__ */ l.jsx(
          Ar,
          {
            className: o <= 1 && "data-table-row-first",
            menuOptionSpecs: M,
            rowValues: F,
            rowData: r
          }
        )
      },
      e + "_actionmenu"
    ),
    C && /* @__PURE__ */ l.jsx("div", { className: "data-table-cell-container", children: " " })
  ] });
}
function Lr({
  columns: e,
  data: r,
  keyFields: t,
  onSortClick: s,
  responsiveStyles: i,
  handleSelectChange: n,
  selectionColumnEnabled: c,
  actionMenuOptions: o,
  allRows: f,
  className: y,
  isRowLocked: h,
  isRowActive: g,
  initialIndex: _,
  size: $,
  rowHeight: L,
  virtualRowEnabled: q,
  isMenuActionVisible: B,
  cellRefs: M
}) {
  return We(() => q ? r.slice(_, _ + $) : r, [_, r, $]).map((T, D) => {
    let m = T.keyIndex;
    for (const C of t)
      if (T[C])
        m = `${m}-${T[C]}`;
      else
        throw "Body row key evaluation: invalid field specified: " + C;
    return /* @__PURE__ */ l.jsx(
      "div",
      {
        className: O(
          "data-table-row-container",
          g ? !g(T) && "inactive" : ""
        ),
        style: { height: L },
        role: "row",
        id: T[t[0]],
        children: /* @__PURE__ */ l.jsx(
          Hr,
          {
            keyFields: t,
            keyPrefix: m,
            rowData: T,
            columns: e,
            rowIndex: D,
            onSortClick: s,
            responsiveStyles: i,
            handleSelectChange: n,
            selectionColumnEnabled: c,
            actionMenuOptions: o,
            className: O("data-table-body-cell", y),
            checked: f.find(
              (C) => C.id == T[t[0]]
            ),
            isRowLocked: h,
            isRowActive: g,
            isMenuActionVisible: B,
            liveDataRef: M[T == null ? void 0 : T.classroomId]
          }
        )
      },
      `${m}`
    );
  });
}
function Rr({
  checked: e,
  handleCheckAll: r,
  checkedRows: t,
  tableContentName: s,
  onSelectNone: i,
  bottomBarOptions: n,
  data: c,
  keyFields: o
}) {
  const f = xe(), y = () => {
    var _;
    i(), (_ = f.current) == null || _.call(f);
  }, h = /* @__PURE__ */ l.jsxs("div", { className: "select-section", children: [
    /* @__PURE__ */ l.jsx(
      Pt,
      {
        id: "button-bar-tricheck",
        value: e,
        labelPresent: !0,
        onChange: r
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: "count-section", children: [
      /* @__PURE__ */ l.jsx(Oe, { className: "select-count", count: t.length }),
      /* @__PURE__ */ l.jsx("label", { children: t.length > 1 ? `${s.plural} selected` : `${s.singular} selected` })
    ] })
  ] }), g = /* @__PURE__ */ l.jsxs("div", { className: "action-section", children: [
    /* @__PURE__ */ l.jsx(De, { onClick: y, children: "Cancel" }),
    n.map((_, $) => /* @__PURE__ */ l.jsx(
      De,
      {
        destructive: _.destructive,
        primary: _.primary,
        icon: _.icon,
        onClick: () => {
          _.targetFunction(
            c.filter((L) => t.includes(L[o[0]]))
          ), f.current = _.cancelFn;
        },
        loader: _.loader,
        disabled: _.disabled,
        children: _.text
      },
      `bottom-bar-button-${$}`
    ))
  ] });
  return /* @__PURE__ */ l.jsx(Kt, { leftSection: h, rightSection: g });
}
const Ur = function(e, r) {
  const t = e;
  return function(s, i) {
    for (let n in t) {
      let c = s[t[n].slice(1)] ?? "", o = i[t[n].slice(1)] ?? "";
      if (c = typeof c == "string" ? c.toLowerCase() : c / 1, o = typeof o == "string" ? o.toLowerCase() : o / 1, t[n].slice(0, 1) == "-" && ([c, o] = [o, c]), c === o)
        return 0;
      if (r) {
        if (c === "")
          return 1;
        if (o === "")
          return -1;
      }
      return c < o ? -1 : 1;
    }
  };
}, Is = function(e, r) {
  return function(t) {
    return t[e] && t[e].length == 1 ? t[e][0] : t[r];
  };
}, $r = function(e, r) {
  return function(t, s) {
    for (let i of e) {
      let n = i(t), c = i(s), o;
      if (n = typeof n == "string" ? n.toLowerCase() : n / 1, c = typeof c == "string" ? c.toLowerCase() : c / 1, r == G.DESCENDING && (o = n, n = c, c = o), n != c)
        return typeof n == "number" && typeof c == "string" ? -1 : typeof n == "string" && typeof c == "number" ? 1 : n < c ? -1 : 1;
    }
  };
}, Qe = function(e, r, t, s) {
  var y;
  if (!r && !t)
    throw "handleSort error: either sortColumn or defaultSortPropName must be specified";
  let i = [...e];
  const n = s ?? G.ASCENDING, c = n == G.ASCENDING ? "+" : "-";
  let o;
  if (r) {
    let h = r.options.sortKeyFunctions;
    if (h && h.length > 0) {
      const g = $r(
        h,
        n
      );
      return i.sort(g);
    }
    o = r.options.sortKeyFields, (!o || o && o.length === 0) && (o = [r.propName]);
  } else
    o = [t];
  const f = o.map((h) => c + h);
  return i.sort(Ur(f, (y = r == null ? void 0 : r.options) == null ? void 0 : y.nullsLast)), i;
}, Mr = { large: 70, medium: 180, small: 240 };
function Br({
  children: e,
  data: r,
  columns: t,
  keyFields: s,
  defaultSortPropName: i,
  defaultSortDirection: n,
  keyPrefix: c,
  zeroStateMessage: o,
  responsiveStyles: f,
  selectionColumnEnabled: y,
  actionMenuOptions: h,
  isRowActive: g,
  bottomBarOptions: _,
  tableContentName: $ = { singular: "row", plural: "rows" },
  isRowLocked: L,
  className: q = "",
  rowHeightConfig: B,
  virtualRowEnabled: M = !1,
  isMenuActionVisible: w = null,
  minViewportHeight: T = null,
  cellRefs: D = []
}) {
  const m = xe(), C = xe(), F = {
    ...Mr,
    ...B
  }, [x, H] = ae([]), [U, Y] = ae(), [N, E] = ae(Ve.EMPTY), [k, P] = ae([]), I = M ? Nt({
    parentRef: C,
    size: U == null ? void 0 : U.length,
    elementHeight: F.large,
    minViewportHeight: T
  }) : {};
  ne(() => {
    const S = r && i ? Qe(
      r,
      he(),
      i,
      n
    ) : [...r];
    Y(S.map((oe, Fe) => ({ ...oe, keyIndex: Fe }))), Q();
    let le = [];
    for (const oe of r)
      L && L(oe) || le.push({ id: oe[s[0]], checked: !1 });
    H(le), M && I.setSize(S.length);
  }, [JSON.stringify(r)]);
  const Z = (S) => {
    const le = Qe(
      U,
      S.sortDirection === G.DEFAULT ? he() : S.column,
      i,
      S.sortDirection || n
    );
    Y(le);
  }, he = () => t == null ? void 0 : t.find(
    (S) => S.propName && S.propName == i
  ), te = () => {
    N !== Ve.CHECKED && x.length > 0 ? (E(Ve.CHECKED), H(x.map((S) => ({ id: S.id, checked: !0 }))), P(x.map((S) => S.id))) : Q();
  }, Q = () => {
    P([]), x.map((S) => {
      S.checked = !1;
    }), H(x);
  }, ie = /* @__PURE__ */ l.jsx(
    Pt,
    {
      id: "headerTriCheck",
      value: N,
      onChange: te
    }
  ), _e = h == null ? void 0 : h.some((S) => S), Ne = y || t[0].type == de.SELECTION, Ee = (S) => {
    const le = x.findIndex((oe) => oe.id == S);
    x[le].checked = !x[le].checked, H(x), x[le].checked ? P((oe) => [...oe, S]) : P(k.filter((oe) => oe != S));
  };
  return ne(() => {
    k.length > 0 && k.length < x.length ? E(Ve.INDETERMINATE) : k.length > 0 && k.length === x.length ? E(Ve.CHECKED) : E(Ve.EMPTY);
  }, [k]), ne(() => {
    M && (f["large-panel"] ? I.setVirtualRowHeight(F.large) : f["medium-panel"] ? I.setVirtualRowHeight(F.medium) : I.setVirtualRowHeight(F.small));
  }, [f]), /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: "table-container-v2",
      ref: C,
      style: {
        height: I == null ? void 0 : I.viewportHeight,
        overflow: "auto"
      },
      role: "table",
      children: [
        U && U.length > 0 && /* @__PURE__ */ l.jsxs(
          "div",
          {
            ref: m,
            className: O(
              "data-table",
              _e && "has-actions",
              Ne && "has-selection",
              f,
              q
            ),
            children: [
              M && /* @__PURE__ */ l.jsx("div", { style: { height: (I == null ? void 0 : I.topHeight) || 0 } }),
              (!M || (I == null ? void 0 : I.initialIndex) === 0 && f["large-panel"]) && /* @__PURE__ */ l.jsx(
                Vr,
                {
                  columns: t,
                  onSortClick: Z,
                  keyPrefix: c,
                  className: "data-table-header-child",
                  headerTriCheck: ie,
                  responsiveStyles: f,
                  hasActionMenu: _e,
                  rowHeight: I == null ? void 0 : I.virtualRowHeight
                }
              ),
              /* @__PURE__ */ l.jsx(
                Lr,
                {
                  data: U,
                  handleSelectChange: Ee,
                  columns: t,
                  keyFields: s,
                  onSortClick: Z,
                  responsiveStyles: f,
                  allRows: x,
                  selectionColumnEnabled: y,
                  actionMenuOptions: _e && h,
                  isRowLocked: L,
                  initialIndex: I.initialIndex,
                  size: I.virtualRows,
                  rowHeight: I == null ? void 0 : I.virtualRowHeight,
                  virtualRowEnabled: M,
                  isRowActive: g,
                  isMenuActionVisible: w,
                  cellRefs: D
                }
              ),
              e,
              M && /* @__PURE__ */ l.jsx("div", { style: { height: (I == null ? void 0 : I.bottomHeight) || 0 } })
            ]
          }
        ),
        U && U.length === 0 && o,
        _ && k.length > 0 && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
          Rr,
          {
            checked: N,
            handleCheckAll: te,
            checkedRows: k,
            tableContentName: $,
            onSelectNone: Q,
            data: r,
            bottomBarOptions: _,
            keyFields: s
          }
        ) })
      ]
    }
  );
}
Br.propTypes = {
  tableContentName: ct.shape({
    singular: ct.string.isRequired,
    plural: ct.string.isRequired
  })
};
function Hs({ children: e, className: r = "" }) {
  const t = xe();
  return /* @__PURE__ */ l.jsx("div", { ref: t, className: O(r), children: e });
}
const Ls = (e) => e ? qt(Number.parseFloat(e), 0) : /* @__PURE__ */ l.jsx(ve, {}), Rs = (e) => e ? Dr(Number.parseFloat(e), 0) : /* @__PURE__ */ l.jsx(ve, {}), Us = (e, r, t = !1) => {
  const s = isNaN(e) ? 0 : e, i = r === "truncate" ? Sr(Number.parseFloat(s)) : qt(Number.parseFloat(s), 0);
  return e || t ? `${i}%` : /* @__PURE__ */ l.jsx(ve, {});
}, $s = ({
  lastName: e,
  firstName: r,
  isCurrentUser: t,
  isAnonymous: s,
  userDetailRoute: i,
  className: n
}) => {
  const c = `${e}, ${r}`, o = s ? /* @__PURE__ */ l.jsx("div", { className: "anonymous-container-avatar", children: /* @__PURE__ */ l.jsx(rt, { icon: ["fa-solid", "user-secret"] }) }) : /* @__PURE__ */ l.jsx(mr, { text: [e, r] });
  return /* @__PURE__ */ l.jsxs("div", { className: O("user-cell-container", n), role: "cell", children: [
    o,
    /* @__PURE__ */ l.jsx("div", { className: "user-cell-name", children: /* @__PURE__ */ l.jsx(Ke, { text: c, children: i ?? c }) }),
    t && /* @__PURE__ */ l.jsx("span", { className: "badge", text: "YOU" })
  ] });
};
function Ms({ collection: e, collectionCount: r }) {
  const t = () => {
    const s = e.join("<br>"), i = e.length > 1 ? e.length : e[0];
    return e.length > 1 ? /* @__PURE__ */ l.jsx(
      jt,
      {
        theme: "text",
        disabled: e.length == 1,
        text: s,
        children: i
      }
    ) : /* @__PURE__ */ l.jsx(Ke, { text: i, children: i });
  };
  return (e == null ? void 0 : e.length) > 0 ? t() : r ? /* @__PURE__ */ l.jsx("span", { children: r }) : /* @__PURE__ */ l.jsx(Wt, {});
}
class Or {
  constructor({
    sortingEnabled: r,
    customFunction: t,
    propName: s,
    sortKeyFields: i,
    sortKeyFunctions: n,
    overflowEnabled: c,
    isFixed: o,
    width: f,
    nullsLast: y,
    isLiveDataColumn: h
    // Only one live column is allowerd to per table
  } = {}) {
    this.sortingEnabled = r, this.customFunction = t, this.propName = s, this.sortKeyFields = i, this.sortKeyFunctions = n, this.overflowEnabled = c, this.isFixed = o, this.width = f, this.nullsLast = y, this.isLiveDataColumn = h;
  }
}
class Bs {
  constructor(r, t, s, i) {
    this.id = r, this.title = t, this.type = s, this.options = i ?? new Or(), this.propName = this.options.propName ?? r;
  }
}
const Pr = ({ column: e, columnIndex: r, cellWidth: t, onSortClick: s }) => {
  var y;
  const { options: i = {} } = e, { isFixed: n } = i, [c, o] = ae(G.DEFAULT), f = (h) => {
    o(h.sortDirection), s(h);
  };
  return /* @__PURE__ */ l.jsx(
    "th",
    {
      className: n && "column-fixed",
      style: {
        width: ((y = e.options) == null ? void 0 : y.width) ?? t,
        left: n ? r * t : void 0
      },
      children: /* @__PURE__ */ l.jsx(
        Ye,
        {
          column: e,
          sortDirection: c,
          onSortClick: f
        }
      )
    }
  );
}, Wr = ({ columns: e, className: r, cellWidth: t, onSortClick: s }) => /* @__PURE__ */ l.jsx("thead", { className: r, children: /* @__PURE__ */ l.jsx("tr", { children: e == null ? void 0 : e.map((i, n) => /* @__PURE__ */ l.jsx(
  Pr,
  {
    cellWidth: t,
    column: i,
    columnIndex: n,
    onSortClick: s
  },
  `${i.id}-${n}`
)) }) }), Kr = ({ column: e, data: r, rowIndex: t }) => {
  var i, n, c, o;
  const s = r[e == null ? void 0 : e.id];
  if (e.type == de.BASIC)
    return /* @__PURE__ */ l.jsx(
      ve,
      {
        value: s ?? "",
        overflowEnabled: (i = e.options) == null ? void 0 : i.overflowEnabled
      }
    );
  if (e.type == de.COUNT)
    return /* @__PURE__ */ l.jsx(ve, { value: s ? /* @__PURE__ */ l.jsx(Oe, { count: s }) : 0 });
  if (e.type == de.LINK) {
    const y = ((n = e.options) == null ? void 0 : n.customFunction(s, r, t)) ?? s;
    return /* @__PURE__ */ l.jsx(
      ve,
      {
        value: y,
        overflowEnabled: (c = e.options) == null ? void 0 : c.overflowEnabled,
        tooltipText: s
      }
    );
  } else if (e.type == de.CUSTOM) {
    const f = (o = e.options) == null ? void 0 : o.customFunction(s, r, t);
    return /* @__PURE__ */ l.jsx(Pe, { children: f });
  }
}, qr = ({ data: e, columns: r, rowIndex: t, cellWidth: s, rowHeight: i }) => /* @__PURE__ */ l.jsx("tr", { style: { height: i }, children: r == null ? void 0 : r.map((n, c) => {
  var o, f, y;
  return /* @__PURE__ */ l.jsx(
    "td",
    {
      style: {
        width: ((o = n.options) == null ? void 0 : o.width) ?? s,
        left: (f = n.options) != null && f.isFixed ? c * s : void 0
      },
      className: ((y = n.options) == null ? void 0 : y.isFixed) && "column-fixed",
      children: Kr({ column: n, data: e, rowIndex: t })
    },
    `${n == null ? void 0 : n.id}-${t}-${c}`
  );
}) }), Gr = ({
  data: e,
  columns: r,
  cellWidth: t,
  initialIndex: s,
  size: i,
  rowHeight: n,
  keyValue: c,
  virtualScrolling: o
}) => {
  const f = We(() => o ? e.slice(s, s + i) : e, [s, e, i, o]);
  return /* @__PURE__ */ l.jsx("tbody", { children: f == null ? void 0 : f.map((y, h) => {
    const g = `table-row-${c ? y[c] : h}`;
    return /* @__PURE__ */ l.jsx(
      qr,
      {
        data: y,
        columns: r,
        cellWidth: t,
        rowHeight: n
      },
      g
    );
  }) });
}, Os = ({
  columns: e,
  data: r,
  staticHeaders: t,
  maxVisibleColumns: s,
  minCellWidth: i = 100,
  onSortClick: n,
  className: c,
  keyValue: o,
  minVisibleRows: f,
  virtualScrolling: y
}) => {
  const [h, g] = ae(0), [_, $] = ae(), L = xe(), q = xe(), B = () => e.filter((F) => {
    var x;
    return !((x = F.options) != null && x.isFixed);
  }).length, M = (F) => {
    if (s && s > 0) {
      const x = B();
      let H = s, U = 0;
      do {
        const Y = H > x ? x : H;
        U = F / Y, H = H - 1;
      } while (U < i && H > 1);
      return U;
    }
  }, w = () => {
    const F = e == null ? void 0 : e.reduce(
      (Y, N) => {
        var E;
        return Y + (((E = N == null ? void 0 : N.options) == null ? void 0 : E.width) ?? 0);
      },
      0
    ), { current: x } = T, { width: H } = x == null ? void 0 : x.getBoundingClientRect(), U = M(H - F);
    g(U);
  };
  ne(() => {
    w(), $(B() > s);
  }, [s, e]), ne(() => {
    y && D.setSize(r == null ? void 0 : r.length);
  }, [r]), ne(() => {
    const F = T.current.parentNode, { height: x } = F == null ? void 0 : F.getBoundingClientRect();
    L.current = x;
  }, []);
  const T = wr(w), D = y ? Nt({
    parentRef: q,
    size: (r == null ? void 0 : r.length) + 1,
    elementHeight: 40,
    tolerance: 5,
    minRows: f
  }) : {}, m = () => {
    const { current: F } = L, { viewportHeight: x, virtualRows: H } = D || {};
    return H === f + 10 ? x : y ? F : void 0;
  }, C = (F) => {
    var N;
    const { scrollLeft: x, scrollWidth: H } = F.target, Y = ((N = q.current) == null ? void 0 : N.offsetWidth) + x < H;
    Y !== _ && $(Y);
  };
  return ne(() => (q.current && q.current.addEventListener("scroll", C), () => {
    var F;
    return (F = q.current) == null ? void 0 : F.removeEventListener(
      "scroll",
      C
    );
  }), [q]), /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: T,
      className: O(
        "table-container",
        _ && "scroll-shadow",
        y && "virtual-scrolling"
      ),
      style: {
        height: D == null ? void 0 : D.viewportHeight,
        maxHeight: m()
      },
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          ref: q,
          className: O(
            "scroll-container",
            h && "overflow-enabled",
            t && "static-headers"
          ),
          style: {
            height: D == null ? void 0 : D.viewportHeight,
            overflow: "auto",
            maxHeight: m()
          },
          children: [
            y && /* @__PURE__ */ l.jsx("div", { style: { height: (D == null ? void 0 : D.topHeight) || 0 } }),
            r && /* @__PURE__ */ l.jsxs("table", { className: c, children: [
              ((D == null ? void 0 : D.initialIndex) === 0 || t) && /* @__PURE__ */ l.jsx(
                Wr,
                {
                  columns: e,
                  cellWidth: h,
                  onSortClick: n
                }
              ),
              /* @__PURE__ */ l.jsx(
                Gr,
                {
                  data: r,
                  columns: e,
                  cellWidth: h,
                  initialIndex: D.initialIndex,
                  size: D.virtualRows,
                  rowHeight: D == null ? void 0 : D.virtualRowHeight,
                  keyValue: o,
                  virtualScrolling: y
                }
              )
            ] }),
            y && /* @__PURE__ */ l.jsx("div", { style: { height: (D == null ? void 0 : D.bottomHeight) || 0 } })
          ]
        }
      )
    }
  );
};
var qe = (e) => e.type === "checkbox", Se = (e) => e instanceof Date, ue = (e) => e == null;
const zt = (e) => typeof e == "object";
var J = (e) => !ue(e) && !Array.isArray(e) && zt(e) && !Se(e), Jt = (e) => J(e) && e.target ? qe(e.target) ? e.target.checked : e.target.value : e, zr = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Yt = (e, r) => e.has(zr(r)), Jr = (e) => {
  const r = e.constructor && e.constructor.prototype;
  return J(r) && r.hasOwnProperty("isPrototypeOf");
}, wt = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ee(e) {
  let r;
  const t = Array.isArray(e);
  if (e instanceof Date)
    r = new Date(e);
  else if (e instanceof Set)
    r = new Set(e);
  else if (!(wt && (e instanceof Blob || e instanceof FileList)) && (t || J(e)))
    if (r = t ? [] : {}, !t && !Jr(e))
      r = e;
    else
      for (const s in e)
        e.hasOwnProperty(s) && (r[s] = ee(e[s]));
  else
    return e;
  return r;
}
var Ge = (e) => Array.isArray(e) ? e.filter(Boolean) : [], K = (e) => e === void 0, p = (e, r, t) => {
  if (!r || !J(e))
    return t;
  const s = Ge(r.split(/[,[\].]+?/)).reduce((i, n) => ue(i) ? i : i[n], e);
  return K(s) || s === e ? K(e[r]) ? t : e[r] : s;
}, ge = (e) => typeof e == "boolean", Dt = (e) => /^\w*$/.test(e), Qt = (e) => Ge(e.replace(/["|']|\]/g, "").split(/\.|\[/)), W = (e, r, t) => {
  let s = -1;
  const i = Dt(r) ? [r] : Qt(r), n = i.length, c = n - 1;
  for (; ++s < n; ) {
    const o = i[s];
    let f = t;
    if (s !== c) {
      const y = e[o];
      f = J(y) || Array.isArray(y) ? y : isNaN(+i[s + 1]) ? {} : [];
    }
    if (o === "__proto__")
      return;
    e[o] = f, e = e[o];
  }
  return e;
};
const Xe = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ye = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, pe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Xt = V.createContext(null), He = () => V.useContext(Xt), Yr = (e) => {
  const { children: r, ...t } = e;
  return V.createElement(Xt.Provider, { value: t }, r);
};
var Zt = (e, r, t, s = !0) => {
  const i = {
    defaultValues: r._defaultValues
  };
  for (const n in e)
    Object.defineProperty(i, n, {
      get: () => {
        const c = n;
        return r._proxyFormState[c] !== ye.all && (r._proxyFormState[c] = !s || ye.all), t && (t[c] = !0), e[c];
      }
    });
  return i;
}, ce = (e) => J(e) && !Object.keys(e).length, er = (e, r, t, s) => {
  t(e);
  const { name: i, ...n } = e;
  return ce(n) || Object.keys(n).length >= Object.keys(r).length || Object.keys(n).find((c) => r[c] === (!s || ye.all));
}, fe = (e) => Array.isArray(e) ? e : [e], tr = (e, r, t) => !e || !r || e === r || fe(e).some((s) => s && (t ? s === r : s.startsWith(r) || r.startsWith(s)));
function st(e) {
  const r = V.useRef(e);
  r.current = e, V.useEffect(() => {
    const t = !e.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function Qr(e) {
  const r = He(), { control: t = r.control, disabled: s, name: i, exact: n } = e || {}, [c, o] = V.useState(t._formState), f = V.useRef(!0), y = V.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), h = V.useRef(i);
  return h.current = i, st({
    disabled: s,
    next: (g) => f.current && tr(h.current, g.name, n) && er(g, y.current, t._updateFormState) && o({
      ...t._formState,
      ...g
    }),
    subject: t._subjects.state
  }), V.useEffect(() => (f.current = !0, y.current.isValid && t._updateValid(!0), () => {
    f.current = !1;
  }), [t]), Zt(c, t, y.current, !1);
}
var be = (e) => typeof e == "string", rr = (e, r, t, s, i) => be(e) ? (s && r.watch.add(e), p(t, e, i)) : Array.isArray(e) ? e.map((n) => (s && r.watch.add(n), p(t, n))) : (s && (r.watchAll = !0), t);
function Xr(e) {
  const r = He(), { control: t = r.control, name: s, defaultValue: i, disabled: n, exact: c } = e || {}, o = V.useRef(s);
  o.current = s, st({
    disabled: n,
    subject: t._subjects.values,
    next: (h) => {
      tr(o.current, h.name, c) && y(ee(rr(o.current, t._names, h.values || t._formValues, !1, i)));
    }
  });
  const [f, y] = V.useState(t._getWatch(s, i));
  return V.useEffect(() => t._removeUnmounted()), f;
}
function Zr(e) {
  const r = He(), { name: t, disabled: s, control: i = r.control, shouldUnregister: n } = e, c = Yt(i._names.array, t), o = Xr({
    control: i,
    name: t,
    defaultValue: p(i._formValues, t, p(i._defaultValues, t, e.defaultValue)),
    exact: !0
  }), f = Qr({
    control: i,
    name: t,
    exact: !0
  }), y = V.useRef(i.register(t, {
    ...e.rules,
    value: o,
    ...ge(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return V.useEffect(() => {
    const h = i._options.shouldUnregister || n, g = (_, $) => {
      const L = p(i._fields, _);
      L && L._f && (L._f.mount = $);
    };
    if (g(t, !0), h) {
      const _ = ee(p(i._options.defaultValues, t));
      W(i._defaultValues, t, _), K(p(i._formValues, t)) && W(i._formValues, t, _);
    }
    return () => {
      (c ? h && !i._state.action : h) ? i.unregister(t) : g(t, !1);
    };
  }, [t, i, c, n]), V.useEffect(() => {
    p(i._fields, t) && i._updateDisabledField({
      disabled: s,
      fields: i._fields,
      name: t,
      value: p(i._fields, t)._f.value
    });
  }, [s, t, i]), {
    field: {
      name: t,
      value: o,
      ...ge(s) || f.disabled ? { disabled: f.disabled || s } : {},
      onChange: V.useCallback((h) => y.current.onChange({
        target: {
          value: Jt(h),
          name: t
        },
        type: Xe.CHANGE
      }), [t]),
      onBlur: V.useCallback(() => y.current.onBlur({
        target: {
          value: p(i._formValues, t),
          name: t
        },
        type: Xe.BLUR
      }), [t, i]),
      ref: V.useCallback((h) => {
        const g = p(i._fields, t);
        g && h && (g._f.ref = {
          focus: () => h.focus(),
          select: () => h.select(),
          setCustomValidity: (_) => h.setCustomValidity(_),
          reportValidity: () => h.reportValidity()
        });
      }, [i._fields, t])
    },
    formState: f,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!p(f.errors, t)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!p(f.dirtyFields, t)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!p(f.touchedFields, t)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!p(f.validatingFields, t)
      },
      error: {
        enumerable: !0,
        get: () => p(f.errors, t)
      }
    })
  };
}
const kt = (e) => e.render(Zr(e));
var es = (e, r, t, s, i) => r ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [s]: i || !0
  }
} : {}, Ce = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    const t = (Math.random() * 16 + e) % 16 | 0;
    return (r == "x" ? t : t & 3 | 8).toString(16);
  });
}, ut = (e, r, t = {}) => t.shouldFocus || K(t.shouldFocus) ? t.focusName || `${e}.${K(t.focusIndex) ? r : t.focusIndex}.` : "", Be = (e) => ({
  isOnSubmit: !e || e === ye.onSubmit,
  isOnBlur: e === ye.onBlur,
  isOnChange: e === ye.onChange,
  isOnAll: e === ye.all,
  isOnTouch: e === ye.onTouched
}), _t = (e, r, t) => !t && (r.watchAll || r.watch.has(e) || [...r.watch].some((s) => e.startsWith(s) && /^\.\w+/.test(e.slice(s.length))));
const ke = (e, r, t, s) => {
  for (const i of t || Object.keys(e)) {
    const n = p(e, i);
    if (n) {
      const { _f: c, ...o } = n;
      if (c) {
        if (c.refs && c.refs[0] && r(c.refs[0], i) && !s)
          return !0;
        if (c.ref && r(c.ref, c.name) && !s)
          return !0;
        if (ke(o, r))
          break;
      } else if (J(o) && ke(o, r))
        break;
    }
  }
};
var sr = (e, r, t) => {
  const s = fe(p(e, t));
  return W(s, "root", r[t]), W(e, t, s), e;
}, St = (e) => e.type === "file", me = (e) => typeof e == "function", Ze = (e) => {
  if (!wt)
    return !1;
  const r = e ? e.ownerDocument : 0;
  return e instanceof (r && r.defaultView ? r.defaultView.HTMLElement : HTMLElement);
}, Je = (e) => be(e), Et = (e) => e.type === "radio", et = (e) => e instanceof RegExp;
const It = {
  value: !1,
  isValid: !1
}, Ht = { value: !0, isValid: !0 };
var ir = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const r = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: r, isValid: !!r.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !K(e[0].attributes.value) ? K(e[0].value) || e[0].value === "" ? Ht : { value: e[0].value, isValid: !0 } : Ht
    ) : It;
  }
  return It;
};
const Lt = {
  isValid: !1,
  value: null
};
var nr = (e) => Array.isArray(e) ? e.reduce((r, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : r, Lt) : Lt;
function Rt(e, r, t = "validate") {
  if (Je(e) || Array.isArray(e) && e.every(Je) || ge(e) && !e)
    return {
      type: t,
      message: Je(e) ? e : "",
      ref: r
    };
}
var Te = (e) => J(e) && !et(e) ? e : {
  value: e,
  message: ""
}, Ft = async (e, r, t, s, i) => {
  const { ref: n, refs: c, required: o, maxLength: f, minLength: y, min: h, max: g, pattern: _, validate: $, name: L, valueAsNumber: q, mount: B, disabled: M } = e._f, w = p(r, L);
  if (!B || M)
    return {};
  const T = c ? c[0] : n, D = (N) => {
    s && T.reportValidity && (T.setCustomValidity(ge(N) ? "" : N || ""), T.reportValidity());
  }, m = {}, C = Et(n), F = qe(n), x = C || F, H = (q || St(n)) && K(n.value) && K(w) || Ze(n) && n.value === "" || w === "" || Array.isArray(w) && !w.length, U = es.bind(null, L, t, m), Y = (N, E, k, P = pe.maxLength, I = pe.minLength) => {
    const Z = N ? E : k;
    m[L] = {
      type: N ? P : I,
      message: Z,
      ref: n,
      ...U(N ? P : I, Z)
    };
  };
  if (i ? !Array.isArray(w) || !w.length : o && (!x && (H || ue(w)) || ge(w) && !w || F && !ir(c).isValid || C && !nr(c).isValid)) {
    const { value: N, message: E } = Je(o) ? { value: !!o, message: o } : Te(o);
    if (N && (m[L] = {
      type: pe.required,
      message: E,
      ref: T,
      ...U(pe.required, E)
    }, !t))
      return D(E), m;
  }
  if (!H && (!ue(h) || !ue(g))) {
    let N, E;
    const k = Te(g), P = Te(h);
    if (!ue(w) && !isNaN(w)) {
      const I = n.valueAsNumber || w && +w;
      ue(k.value) || (N = I > k.value), ue(P.value) || (E = I < P.value);
    } else {
      const I = n.valueAsDate || new Date(w), Z = (Q) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Q), he = n.type == "time", te = n.type == "week";
      be(k.value) && w && (N = he ? Z(w) > Z(k.value) : te ? w > k.value : I > new Date(k.value)), be(P.value) && w && (E = he ? Z(w) < Z(P.value) : te ? w < P.value : I < new Date(P.value));
    }
    if ((N || E) && (Y(!!N, k.message, P.message, pe.max, pe.min), !t))
      return D(m[L].message), m;
  }
  if ((f || y) && !H && (be(w) || i && Array.isArray(w))) {
    const N = Te(f), E = Te(y), k = !ue(N.value) && w.length > +N.value, P = !ue(E.value) && w.length < +E.value;
    if ((k || P) && (Y(k, N.message, E.message), !t))
      return D(m[L].message), m;
  }
  if (_ && !H && be(w)) {
    const { value: N, message: E } = Te(_);
    if (et(N) && !w.match(N) && (m[L] = {
      type: pe.pattern,
      message: E,
      ref: n,
      ...U(pe.pattern, E)
    }, !t))
      return D(E), m;
  }
  if ($) {
    if (me($)) {
      const N = await $(w, r), E = Rt(N, T);
      if (E && (m[L] = {
        ...E,
        ...U(pe.validate, E.message)
      }, !t))
        return D(E.message), m;
    } else if (J($)) {
      let N = {};
      for (const E in $) {
        if (!ce(N) && !t)
          break;
        const k = Rt(await $[E](w, r), T, E);
        k && (N = {
          ...k,
          ...U(E, k.message)
        }, D(k.message), t && (m[L] = N));
      }
      if (!ce(N) && (m[L] = {
        ref: T,
        ...N
      }, !t))
        return m;
    }
  }
  return D(!0), m;
}, dt = (e, r) => [
  ...e,
  ...fe(r)
], ft = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function ht(e, r, t) {
  return [
    ...e.slice(0, r),
    ...fe(t),
    ...e.slice(r)
  ];
}
var gt = (e, r, t) => Array.isArray(e) ? (K(e[t]) && (e[t] = void 0), e.splice(t, 0, e.splice(r, 1)[0]), e) : [], yt = (e, r) => [
  ...fe(r),
  ...fe(e)
];
function ts(e, r) {
  let t = 0;
  const s = [...e];
  for (const i of r)
    s.splice(i - t, 1), t++;
  return Ge(s).length ? s : [];
}
var xt = (e, r) => K(r) ? [] : ts(e, fe(r).sort((t, s) => t - s)), mt = (e, r, t) => {
  [e[r], e[t]] = [e[t], e[r]];
};
function rs(e, r) {
  const t = r.slice(0, -1).length;
  let s = 0;
  for (; s < t; )
    e = K(e) ? s++ : e[r[s++]];
  return e;
}
function ss(e) {
  for (const r in e)
    if (e.hasOwnProperty(r) && !K(e[r]))
      return !1;
  return !0;
}
function X(e, r) {
  const t = Array.isArray(r) ? r : Dt(r) ? [r] : Qt(r), s = t.length === 1 ? e : rs(e, t), i = t.length - 1, n = t[i];
  return s && delete s[n], i !== 0 && (J(s) && ce(s) || Array.isArray(s) && ss(s)) && X(e, t.slice(0, -1)), e;
}
var Ut = (e, r, t) => (e[r] = t, e);
function is(e) {
  const r = He(), { control: t = r.control, name: s, keyName: i = "id", shouldUnregister: n } = e, [c, o] = V.useState(t._getFieldArray(s)), f = V.useRef(t._getFieldArray(s).map(Ce)), y = V.useRef(c), h = V.useRef(s), g = V.useRef(!1);
  h.current = s, y.current = c, t._names.array.add(s), e.rules && t.register(s, e.rules), st({
    next: ({ values: m, name: C }) => {
      if (C === h.current || !C) {
        const F = p(m, h.current);
        Array.isArray(F) && (o(F), f.current = F.map(Ce));
      }
    },
    subject: t._subjects.array
  });
  const _ = V.useCallback((m) => {
    g.current = !0, t._updateFieldArray(s, m);
  }, [t, s]), $ = (m, C) => {
    const F = fe(ee(m)), x = dt(t._getFieldArray(s), F);
    t._names.focus = ut(s, x.length - 1, C), f.current = dt(f.current, F.map(Ce)), _(x), o(x), t._updateFieldArray(s, x, dt, {
      argA: ft(m)
    });
  }, L = (m, C) => {
    const F = fe(ee(m)), x = yt(t._getFieldArray(s), F);
    t._names.focus = ut(s, 0, C), f.current = yt(f.current, F.map(Ce)), _(x), o(x), t._updateFieldArray(s, x, yt, {
      argA: ft(m)
    });
  }, q = (m) => {
    const C = xt(t._getFieldArray(s), m);
    f.current = xt(f.current, m), _(C), o(C), t._updateFieldArray(s, C, xt, {
      argA: m
    });
  }, B = (m, C, F) => {
    const x = fe(ee(C)), H = ht(t._getFieldArray(s), m, x);
    t._names.focus = ut(s, m, F), f.current = ht(f.current, m, x.map(Ce)), _(H), o(H), t._updateFieldArray(s, H, ht, {
      argA: m,
      argB: ft(C)
    });
  }, M = (m, C) => {
    const F = t._getFieldArray(s);
    mt(F, m, C), mt(f.current, m, C), _(F), o(F), t._updateFieldArray(s, F, mt, {
      argA: m,
      argB: C
    }, !1);
  }, w = (m, C) => {
    const F = t._getFieldArray(s);
    gt(F, m, C), gt(f.current, m, C), _(F), o(F), t._updateFieldArray(s, F, gt, {
      argA: m,
      argB: C
    }, !1);
  }, T = (m, C) => {
    const F = ee(C), x = Ut(t._getFieldArray(s), m, F);
    f.current = [...x].map((H, U) => !H || U === m ? Ce() : f.current[U]), _(x), o([...x]), t._updateFieldArray(s, x, Ut, {
      argA: m,
      argB: F
    }, !0, !1);
  }, D = (m) => {
    const C = fe(ee(m));
    f.current = C.map(Ce), _([...C]), o([...C]), t._updateFieldArray(s, [...C], (F) => F, {}, !0, !1);
  };
  return V.useEffect(() => {
    if (t._state.action = !1, _t(s, t._names) && t._subjects.state.next({
      ...t._formState
    }), g.current && (!Be(t._options.mode).isOnSubmit || t._formState.isSubmitted))
      if (t._options.resolver)
        t._executeSchema([s]).then((m) => {
          const C = p(m.errors, s), F = p(t._formState.errors, s);
          (F ? !C && F.type || C && (F.type !== C.type || F.message !== C.message) : C && C.type) && (C ? W(t._formState.errors, s, C) : X(t._formState.errors, s), t._subjects.state.next({
            errors: t._formState.errors
          }));
        });
      else {
        const m = p(t._fields, s);
        m && m._f && !(Be(t._options.reValidateMode).isOnSubmit && Be(t._options.mode).isOnSubmit) && Ft(m, t._formValues, t._options.criteriaMode === ye.all, t._options.shouldUseNativeValidation, !0).then((C) => !ce(C) && t._subjects.state.next({
          errors: sr(t._formState.errors, C, s)
        }));
      }
    t._subjects.values.next({
      name: s,
      values: { ...t._formValues }
    }), t._names.focus && ke(t._fields, (m, C) => {
      if (t._names.focus && C.startsWith(t._names.focus) && m.focus)
        return m.focus(), 1;
    }), t._names.focus = "", t._updateValid(), g.current = !1;
  }, [c, s, t]), V.useEffect(() => (!p(t._formValues, s) && t._updateFieldArray(s), () => {
    (t._options.shouldUnregister || n) && t.unregister(s);
  }), [s, t, i, n]), {
    swap: V.useCallback(M, [_, s, t]),
    move: V.useCallback(w, [_, s, t]),
    prepend: V.useCallback(L, [_, s, t]),
    append: V.useCallback($, [_, s, t]),
    remove: V.useCallback(q, [_, s, t]),
    insert: V.useCallback(B, [_, s, t]),
    update: V.useCallback(T, [_, s, t]),
    replace: V.useCallback(D, [_, s, t]),
    fields: V.useMemo(() => c.map((m, C) => ({
      ...m,
      [i]: f.current[C] || Ce()
    })), [c, i])
  };
}
var bt = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const n of e)
        n.next && n.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((n) => n !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Ct = (e) => ue(e) || !zt(e);
function je(e, r) {
  if (Ct(e) || Ct(r))
    return e === r;
  if (Se(e) && Se(r))
    return e.getTime() === r.getTime();
  const t = Object.keys(e), s = Object.keys(r);
  if (t.length !== s.length)
    return !1;
  for (const i of t) {
    const n = e[i];
    if (!s.includes(i))
      return !1;
    if (i !== "ref") {
      const c = r[i];
      if (Se(n) && Se(c) || J(n) && J(c) || Array.isArray(n) && Array.isArray(c) ? !je(n, c) : n !== c)
        return !1;
    }
  }
  return !0;
}
var ar = (e) => e.type === "select-multiple", ns = (e) => Et(e) || qe(e), pt = (e) => Ze(e) && e.isConnected, lr = (e) => {
  for (const r in e)
    if (me(e[r]))
      return !0;
  return !1;
};
function tt(e, r = {}) {
  const t = Array.isArray(e);
  if (J(e) || t)
    for (const s in e)
      Array.isArray(e[s]) || J(e[s]) && !lr(e[s]) ? (r[s] = Array.isArray(e[s]) ? [] : {}, tt(e[s], r[s])) : ue(e[s]) || (r[s] = !0);
  return r;
}
function or(e, r, t) {
  const s = Array.isArray(e);
  if (J(e) || s)
    for (const i in e)
      Array.isArray(e[i]) || J(e[i]) && !lr(e[i]) ? K(r) || Ct(t[i]) ? t[i] = Array.isArray(e[i]) ? tt(e[i], []) : { ...tt(e[i]) } : or(e[i], ue(r) ? {} : r[i], t[i]) : t[i] = !je(e[i], r[i]);
  return t;
}
var $e = (e, r) => or(e, r, tt(r)), cr = (e, { valueAsNumber: r, valueAsDate: t, setValueAs: s }) => K(e) ? e : r ? e === "" ? NaN : e && +e : t && be(e) ? new Date(e) : s ? s(e) : e;
function vt(e) {
  const r = e.ref;
  if (!(e.refs ? e.refs.every((t) => t.disabled) : r.disabled))
    return St(r) ? r.files : Et(r) ? nr(e.refs).value : ar(r) ? [...r.selectedOptions].map(({ value: t }) => t) : qe(r) ? ir(e.refs).value : cr(K(r.value) ? e.ref.value : r.value, e);
}
var as = (e, r, t, s) => {
  const i = {};
  for (const n of e) {
    const c = p(r, n);
    c && W(i, n, c._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: s
  };
}, Me = (e) => K(e) ? e : et(e) ? e.source : J(e) ? et(e.value) ? e.value.source : e.value : e;
const $t = "AsyncFunction";
var ls = (e) => (!e || !e.validate) && !!(me(e.validate) && e.validate.constructor.name === $t || J(e.validate) && Object.values(e.validate).find((r) => r.constructor.name === $t)), os = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Mt(e, r, t) {
  const s = p(e, t);
  if (s || Dt(t))
    return {
      error: s,
      name: t
    };
  const i = t.split(".");
  for (; i.length; ) {
    const n = i.join("."), c = p(r, n), o = p(e, n);
    if (c && !Array.isArray(c) && t !== n)
      return { name: t };
    if (o && o.type)
      return {
        name: n,
        error: o
      };
    i.pop();
  }
  return {
    name: t
  };
}
var cs = (e, r, t, s, i) => i.isOnAll ? !1 : !t && i.isOnTouch ? !(r || e) : (t ? s.isOnBlur : i.isOnBlur) ? !e : (t ? s.isOnChange : i.isOnChange) ? e : !0, us = (e, r) => !Ge(p(e, r)).length && X(e, r);
const ds = {
  mode: ye.onSubmit,
  reValidateMode: ye.onChange,
  shouldFocusError: !0
};
function fs(e = {}) {
  let r = {
    ...ds,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: me(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: r.errors || {},
    disabled: r.disabled || !1
  }, s = {}, i = J(r.defaultValues) || J(r.values) ? ee(r.defaultValues || r.values) || {} : {}, n = r.shouldUnregister ? {} : ee(i), c = {
    action: !1,
    mount: !1,
    watch: !1
  }, o = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, f, y = 0;
  const h = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, g = {
    values: bt(),
    array: bt(),
    state: bt()
  }, _ = Be(r.mode), $ = Be(r.reValidateMode), L = r.criteriaMode === ye.all, q = (a) => (u) => {
    clearTimeout(y), y = setTimeout(a, u);
  }, B = async (a) => {
    if (!r.disabled && (h.isValid || a)) {
      const u = r.resolver ? ce((await x()).errors) : await U(s, !0);
      u !== t.isValid && g.state.next({
        isValid: u
      });
    }
  }, M = (a, u) => {
    !r.disabled && (h.isValidating || h.validatingFields) && ((a || Array.from(o.mount)).forEach((d) => {
      d && (u ? W(t.validatingFields, d, u) : X(t.validatingFields, d));
    }), g.state.next({
      validatingFields: t.validatingFields,
      isValidating: !ce(t.validatingFields)
    }));
  }, w = (a, u = [], d, j, v = !0, b = !0) => {
    if (j && d && !r.disabled) {
      if (c.action = !0, b && Array.isArray(p(s, a))) {
        const A = d(p(s, a), j.argA, j.argB);
        v && W(s, a, A);
      }
      if (b && Array.isArray(p(t.errors, a))) {
        const A = d(p(t.errors, a), j.argA, j.argB);
        v && W(t.errors, a, A), us(t.errors, a);
      }
      if (h.touchedFields && b && Array.isArray(p(t.touchedFields, a))) {
        const A = d(p(t.touchedFields, a), j.argA, j.argB);
        v && W(t.touchedFields, a, A);
      }
      h.dirtyFields && (t.dirtyFields = $e(i, n)), g.state.next({
        name: a,
        isDirty: N(a, u),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      W(n, a, u);
  }, T = (a, u) => {
    W(t.errors, a, u), g.state.next({
      errors: t.errors
    });
  }, D = (a) => {
    t.errors = a, g.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, m = (a, u, d, j) => {
    const v = p(s, a);
    if (v) {
      const b = p(n, a, K(d) ? p(i, a) : d);
      K(b) || j && j.defaultChecked || u ? W(n, a, u ? b : vt(v._f)) : P(a, b), c.mount && B();
    }
  }, C = (a, u, d, j, v) => {
    let b = !1, A = !1;
    const R = {
      name: a
    };
    if (!r.disabled) {
      const re = !!(p(s, a) && p(s, a)._f && p(s, a)._f.disabled);
      if (!d || j) {
        h.isDirty && (A = t.isDirty, t.isDirty = R.isDirty = N(), b = A !== R.isDirty);
        const se = re || je(p(i, a), u);
        A = !!(!re && p(t.dirtyFields, a)), se || re ? X(t.dirtyFields, a) : W(t.dirtyFields, a, !0), R.dirtyFields = t.dirtyFields, b = b || h.dirtyFields && A !== !se;
      }
      if (d) {
        const se = p(t.touchedFields, a);
        se || (W(t.touchedFields, a, d), R.touchedFields = t.touchedFields, b = b || h.touchedFields && se !== d);
      }
      b && v && g.state.next(R);
    }
    return b ? R : {};
  }, F = (a, u, d, j) => {
    const v = p(t.errors, a), b = h.isValid && ge(u) && t.isValid !== u;
    if (e.delayError && d ? (f = q(() => T(a, d)), f(e.delayError)) : (clearTimeout(y), f = null, d ? W(t.errors, a, d) : X(t.errors, a)), (d ? !je(v, d) : v) || !ce(j) || b) {
      const A = {
        ...j,
        ...b && ge(u) ? { isValid: u } : {},
        errors: t.errors,
        name: a
      };
      t = {
        ...t,
        ...A
      }, g.state.next(A);
    }
  }, x = async (a) => {
    M(a, !0);
    const u = await r.resolver(n, r.context, as(a || o.mount, s, r.criteriaMode, r.shouldUseNativeValidation));
    return M(a), u;
  }, H = async (a) => {
    const { errors: u } = await x(a);
    if (a)
      for (const d of a) {
        const j = p(u, d);
        j ? W(t.errors, d, j) : X(t.errors, d);
      }
    else
      t.errors = u;
    return u;
  }, U = async (a, u, d = {
    valid: !0
  }) => {
    for (const j in a) {
      const v = a[j];
      if (v) {
        const { _f: b, ...A } = v;
        if (b) {
          const R = o.array.has(b.name), re = v._f && ls(v._f);
          re && h.validatingFields && M([j], !0);
          const se = await Ft(v, n, L, r.shouldUseNativeValidation && !u, R);
          if (re && h.validatingFields && M([j]), se[b.name] && (d.valid = !1, u))
            break;
          !u && (p(se, b.name) ? R ? sr(t.errors, se, b.name) : W(t.errors, b.name, se[b.name]) : X(t.errors, b.name));
        }
        !ce(A) && await U(A, u, d);
      }
    }
    return d.valid;
  }, Y = () => {
    for (const a of o.unMount) {
      const u = p(s, a);
      u && (u._f.refs ? u._f.refs.every((d) => !pt(d)) : !pt(u._f.ref)) && le(a);
    }
    o.unMount = /* @__PURE__ */ new Set();
  }, N = (a, u) => !r.disabled && (a && u && W(n, a, u), !je(ie(), i)), E = (a, u, d) => rr(a, o, {
    ...c.mount ? n : K(u) ? i : be(a) ? { [a]: u } : u
  }, d, u), k = (a) => Ge(p(c.mount ? n : i, a, e.shouldUnregister ? p(i, a, []) : [])), P = (a, u, d = {}) => {
    const j = p(s, a);
    let v = u;
    if (j) {
      const b = j._f;
      b && (!b.disabled && W(n, a, cr(u, b)), v = Ze(b.ref) && ue(u) ? "" : u, ar(b.ref) ? [...b.ref.options].forEach((A) => A.selected = v.includes(A.value)) : b.refs ? qe(b.ref) ? b.refs.length > 1 ? b.refs.forEach((A) => (!A.defaultChecked || !A.disabled) && (A.checked = Array.isArray(v) ? !!v.find((R) => R === A.value) : v === A.value)) : b.refs[0] && (b.refs[0].checked = !!v) : b.refs.forEach((A) => A.checked = A.value === v) : St(b.ref) ? b.ref.value = "" : (b.ref.value = v, b.ref.type || g.values.next({
        name: a,
        values: { ...n }
      })));
    }
    (d.shouldDirty || d.shouldTouch) && C(a, v, d.shouldTouch, d.shouldDirty, !0), d.shouldValidate && Q(a);
  }, I = (a, u, d) => {
    for (const j in u) {
      const v = u[j], b = `${a}.${j}`, A = p(s, b);
      (o.array.has(a) || J(v) || A && !A._f) && !Se(v) ? I(b, v, d) : P(b, v, d);
    }
  }, Z = (a, u, d = {}) => {
    const j = p(s, a), v = o.array.has(a), b = ee(u);
    W(n, a, b), v ? (g.array.next({
      name: a,
      values: { ...n }
    }), (h.isDirty || h.dirtyFields) && d.shouldDirty && g.state.next({
      name: a,
      dirtyFields: $e(i, n),
      isDirty: N(a, b)
    })) : j && !j._f && !ue(b) ? I(a, b, d) : P(a, b, d), _t(a, o) && g.state.next({ ...t }), g.values.next({
      name: c.mount ? a : void 0,
      values: { ...n }
    });
  }, he = async (a) => {
    c.mount = !0;
    const u = a.target;
    let d = u.name, j = !0;
    const v = p(s, d), b = () => u.type ? vt(v._f) : Jt(a), A = (R) => {
      j = Number.isNaN(R) || Se(R) && isNaN(R.getTime()) || je(R, p(n, d, R));
    };
    if (v) {
      let R, re;
      const se = b(), we = a.type === Xe.BLUR || a.type === Xe.FOCUS_OUT, fr = !os(v._f) && !r.resolver && !p(t.errors, d) && !v._f.deps || cs(we, p(t.touchedFields, d), t.isSubmitted, $, _), lt = _t(d, o, we);
      W(n, d, se), we ? (v._f.onBlur && v._f.onBlur(a), f && f(0)) : v._f.onChange && v._f.onChange(a);
      const ot = C(d, se, we, !1), hr = !ce(ot) || lt;
      if (!we && g.values.next({
        name: d,
        type: a.type,
        values: { ...n }
      }), fr)
        return h.isValid && (e.mode === "onBlur" ? we && B() : B()), hr && g.state.next({ name: d, ...lt ? {} : ot });
      if (!we && lt && g.state.next({ ...t }), r.resolver) {
        const { errors: Vt } = await x([d]);
        if (A(se), j) {
          const gr = Mt(t.errors, s, d), Tt = Mt(Vt, s, gr.name || d);
          R = Tt.error, d = Tt.name, re = ce(Vt);
        }
      } else
        M([d], !0), R = (await Ft(v, n, L, r.shouldUseNativeValidation))[d], M([d]), A(se), j && (R ? re = !1 : h.isValid && (re = await U(s, !0)));
      j && (v._f.deps && Q(v._f.deps), F(d, re, R, ot));
    }
  }, te = (a, u) => {
    if (p(t.errors, u) && a.focus)
      return a.focus(), 1;
  }, Q = async (a, u = {}) => {
    let d, j;
    const v = fe(a);
    if (r.resolver) {
      const b = await H(K(a) ? a : v);
      d = ce(b), j = a ? !v.some((A) => p(b, A)) : d;
    } else a ? (j = (await Promise.all(v.map(async (b) => {
      const A = p(s, b);
      return await U(A && A._f ? { [b]: A } : A);
    }))).every(Boolean), !(!j && !t.isValid) && B()) : j = d = await U(s);
    return g.state.next({
      ...!be(a) || h.isValid && d !== t.isValid ? {} : { name: a },
      ...r.resolver || !a ? { isValid: d } : {},
      errors: t.errors
    }), u.shouldFocus && !j && ke(s, te, a ? v : o.mount), j;
  }, ie = (a) => {
    const u = {
      ...c.mount ? n : i
    };
    return K(a) ? u : be(a) ? p(u, a) : a.map((d) => p(u, d));
  }, _e = (a, u) => ({
    invalid: !!p((u || t).errors, a),
    isDirty: !!p((u || t).dirtyFields, a),
    error: p((u || t).errors, a),
    isValidating: !!p(t.validatingFields, a),
    isTouched: !!p((u || t).touchedFields, a)
  }), Ne = (a) => {
    a && fe(a).forEach((u) => X(t.errors, u)), g.state.next({
      errors: a ? t.errors : {}
    });
  }, Ee = (a, u, d) => {
    const j = (p(s, a, { _f: {} })._f || {}).ref, v = p(t.errors, a) || {}, { ref: b, message: A, type: R, ...re } = v;
    W(t.errors, a, {
      ...re,
      ...u,
      ref: j
    }), g.state.next({
      name: a,
      errors: t.errors,
      isValid: !1
    }), d && d.shouldFocus && j && j.focus && j.focus();
  }, S = (a, u) => me(a) ? g.values.subscribe({
    next: (d) => a(E(void 0, u), d)
  }) : E(a, u, !0), le = (a, u = {}) => {
    for (const d of a ? fe(a) : o.mount)
      o.mount.delete(d), o.array.delete(d), u.keepValue || (X(s, d), X(n, d)), !u.keepError && X(t.errors, d), !u.keepDirty && X(t.dirtyFields, d), !u.keepTouched && X(t.touchedFields, d), !u.keepIsValidating && X(t.validatingFields, d), !r.shouldUnregister && !u.keepDefaultValue && X(i, d);
    g.values.next({
      values: { ...n }
    }), g.state.next({
      ...t,
      ...u.keepDirty ? { isDirty: N() } : {}
    }), !u.keepIsValid && B();
  }, oe = ({ disabled: a, name: u, field: d, fields: j, value: v }) => {
    if (ge(a) && c.mount || a) {
      const b = a ? void 0 : K(v) ? vt(d ? d._f : p(j, u)._f) : v;
      W(n, u, b), C(u, b, !1, !1, !0);
    }
  }, Fe = (a, u = {}) => {
    let d = p(s, a);
    const j = ge(u.disabled) || ge(r.disabled);
    return W(s, a, {
      ...d || {},
      _f: {
        ...d && d._f ? d._f : { ref: { name: a } },
        name: a,
        mount: !0,
        ...u
      }
    }), o.mount.add(a), d ? oe({
      field: d,
      disabled: ge(u.disabled) ? u.disabled : r.disabled,
      name: a,
      value: u.value
    }) : m(a, !0, u.value), {
      ...j ? { disabled: u.disabled || r.disabled } : {},
      ...r.progressive ? {
        required: !!u.required,
        min: Me(u.min),
        max: Me(u.max),
        minLength: Me(u.minLength),
        maxLength: Me(u.maxLength),
        pattern: Me(u.pattern)
      } : {},
      name: a,
      onChange: he,
      onBlur: he,
      ref: (v) => {
        if (v) {
          Fe(a, u), d = p(s, a);
          const b = K(v.value) && v.querySelectorAll && v.querySelectorAll("input,select,textarea")[0] || v, A = ns(b), R = d._f.refs || [];
          if (A ? R.find((re) => re === b) : b === d._f.ref)
            return;
          W(s, a, {
            _f: {
              ...d._f,
              ...A ? {
                refs: [
                  ...R.filter(pt),
                  b,
                  ...Array.isArray(p(i, a)) ? [{}] : []
                ],
                ref: { type: b.type, name: a }
              } : { ref: b }
            }
          }), m(a, !1, void 0, b);
        } else
          d = p(s, a, {}), d._f && (d._f.mount = !1), (r.shouldUnregister || u.shouldUnregister) && !(Yt(o.array, a) && c.action) && o.unMount.add(a);
      }
    };
  }, Le = () => r.shouldFocusError && ke(s, te, o.mount), it = (a) => {
    ge(a) && (g.state.next({ disabled: a }), ke(s, (u, d) => {
      const j = p(s, d);
      j && (u.disabled = j._f.disabled || a, Array.isArray(j._f.refs) && j._f.refs.forEach((v) => {
        v.disabled = j._f.disabled || a;
      }));
    }, 0, !1));
  }, z = (a, u) => async (d) => {
    let j;
    if (d && (d.preventDefault && d.preventDefault(), d.persist && d.persist()), r.disabled) {
      u && await u({ ...t.errors }, d);
      return;
    }
    let v = ee(n);
    if (g.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: b, values: A } = await x();
      t.errors = b, v = A;
    } else
      await U(s);
    if (X(t.errors, "root"), ce(t.errors)) {
      g.state.next({
        errors: {}
      });
      try {
        await a(v, d);
      } catch (b) {
        j = b;
      }
    } else
      u && await u({ ...t.errors }, d), Le(), setTimeout(Le);
    if (g.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ce(t.errors) && !j,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), j)
      throw j;
  }, Ae = (a, u = {}) => {
    p(s, a) && (K(u.defaultValue) ? Z(a, ee(p(i, a))) : (Z(a, u.defaultValue), W(i, a, ee(u.defaultValue))), u.keepTouched || X(t.touchedFields, a), u.keepDirty || (X(t.dirtyFields, a), t.isDirty = u.defaultValue ? N(a, ee(p(i, a))) : N()), u.keepError || (X(t.errors, a), h.isValid && B()), g.state.next({ ...t }));
  }, Re = (a, u = {}) => {
    const d = a ? ee(a) : i, j = ee(d), v = ce(a), b = v ? i : j;
    if (u.keepDefaultValues || (i = d), !u.keepValues) {
      if (u.keepDirtyValues) {
        const A = /* @__PURE__ */ new Set([
          ...o.mount,
          ...Object.keys($e(i, n))
        ]);
        for (const R of Array.from(A))
          p(t.dirtyFields, R) ? W(b, R, p(n, R)) : Z(R, p(b, R));
      } else {
        if (wt && K(a))
          for (const A of o.mount) {
            const R = p(s, A);
            if (R && R._f) {
              const re = Array.isArray(R._f.refs) ? R._f.refs[0] : R._f.ref;
              if (Ze(re)) {
                const se = re.closest("form");
                if (se) {
                  se.reset();
                  break;
                }
              }
            }
          }
        s = {};
      }
      n = e.shouldUnregister ? u.keepDefaultValues ? ee(i) : {} : ee(b), g.array.next({
        values: { ...b }
      }), g.values.next({
        values: { ...b }
      });
    }
    o = {
      mount: u.keepDirtyValues ? o.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, c.mount = !h.isValid || !!u.keepIsValid || !!u.keepDirtyValues, c.watch = !!e.shouldUnregister, g.state.next({
      submitCount: u.keepSubmitCount ? t.submitCount : 0,
      isDirty: v ? !1 : u.keepDirty ? t.isDirty : !!(u.keepDefaultValues && !je(a, i)),
      isSubmitted: u.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: v ? {} : u.keepDirtyValues ? u.keepDefaultValues && n ? $e(i, n) : t.dirtyFields : u.keepDefaultValues && a ? $e(i, a) : u.keepDirty ? t.dirtyFields : {},
      touchedFields: u.keepTouched ? t.touchedFields : {},
      errors: u.keepErrors ? t.errors : {},
      isSubmitSuccessful: u.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, nt = (a, u) => Re(me(a) ? a(n) : a, u);
  return {
    control: {
      register: Fe,
      unregister: le,
      getFieldState: _e,
      handleSubmit: z,
      setError: Ee,
      _executeSchema: x,
      _getWatch: E,
      _getDirty: N,
      _updateValid: B,
      _removeUnmounted: Y,
      _updateFieldArray: w,
      _updateDisabledField: oe,
      _getFieldArray: k,
      _reset: Re,
      _resetDefaultValues: () => me(r.defaultValues) && r.defaultValues().then((a) => {
        nt(a, r.resetOptions), g.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (a) => {
        t = {
          ...t,
          ...a
        };
      },
      _disableForm: it,
      _subjects: g,
      _proxyFormState: h,
      _setErrors: D,
      get _fields() {
        return s;
      },
      get _formValues() {
        return n;
      },
      get _state() {
        return c;
      },
      set _state(a) {
        c = a;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return o;
      },
      set _names(a) {
        o = a;
      },
      get _formState() {
        return t;
      },
      set _formState(a) {
        t = a;
      },
      get _options() {
        return r;
      },
      set _options(a) {
        r = {
          ...r,
          ...a
        };
      }
    },
    trigger: Q,
    register: Fe,
    handleSubmit: z,
    watch: S,
    setValue: Z,
    getValues: ie,
    reset: nt,
    resetField: Ae,
    clearErrors: Ne,
    unregister: le,
    setError: Ee,
    setFocus: (a, u = {}) => {
      const d = p(s, a), j = d && d._f;
      if (j) {
        const v = j.refs ? j.refs[0] : j.ref;
        v.focus && (v.focus(), u.shouldSelect && me(v.select) && v.select());
      }
    },
    getFieldState: _e
  };
}
function hs(e = {}) {
  const r = V.useRef(), t = V.useRef(), [s, i] = V.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: me(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: me(e.defaultValues) ? void 0 : e.defaultValues
  });
  r.current || (r.current = {
    ...fs(e),
    formState: s
  });
  const n = r.current.control;
  return n._options = e, st({
    subject: n._subjects.state,
    next: (c) => {
      er(c, n._proxyFormState, n._updateFormState, !0) && i({ ...n._formState });
    }
  }), V.useEffect(() => n._disableForm(e.disabled), [n, e.disabled]), V.useEffect(() => {
    if (n._proxyFormState.isDirty) {
      const c = n._getDirty();
      c !== s.isDirty && n._subjects.state.next({
        isDirty: c
      });
    }
  }, [n, s.isDirty]), V.useEffect(() => {
    e.values && !je(e.values, t.current) ? (n._reset(e.values, n._options.resetOptions), t.current = e.values, i((c) => ({ ...c }))) : n._resetDefaultValues();
  }, [e.values, n]), V.useEffect(() => {
    e.errors && n._setErrors(e.errors);
  }, [e.errors, n]), V.useEffect(() => {
    n._state.mount || (n._updateValid(), n._state.mount = !0), n._state.watch && (n._state.watch = !1, n._subjects.state.next({ ...n._formState })), n._removeUnmounted();
  }), V.useEffect(() => {
    e.shouldUnregister && n._subjects.values.next({
      values: n._getWatch()
    });
  }, [e.shouldUnregister, n]), r.current.formState = Zt(s, n), r.current;
}
function ur({
  column: e,
  sortDirection: r = 0,
  onSortClick: t,
  className: s
}) {
  var c, o, f;
  const i = xe(), n = function() {
    let y;
    r == G.DEFAULT ? y = G.ASCENDING : r == G.ASCENDING ? y = G.DESCENDING : r == G.DESCENDING && (y = G.DEFAULT), t(new Gt(e, y));
  };
  return /* @__PURE__ */ l.jsx("div", { ref: i, className: O(s), role: "columnheader", children: /* @__PURE__ */ l.jsxs(
    "button",
    {
      className: "form-table-header-column-text-container",
      onClick: () => e.options.sortingEnabled && n(),
      tabIndex: "0",
      "aria-label": "Sort the " + e.title + " Column",
      children: [
        /* @__PURE__ */ l.jsx("div", { className: "form-table-header-column-text", tabIndex: "-1", children: /* @__PURE__ */ l.jsx(Ke, { text: e.title, children: e.title }) }),
        ((c = e.options) == null ? void 0 : c.sortingEnabled) && /* @__PURE__ */ l.jsx(
          Ot,
          {
            column: e,
            sortDirection: r,
            tabIndex: "-1"
          }
        ),
        ((o = e.options) == null ? void 0 : o.hasInfo) && /* @__PURE__ */ l.jsx("div", { className: "info-icon", children: /* @__PURE__ */ l.jsx(jt, { text: (f = e.options) == null ? void 0 : f.hasInfo, children: /* @__PURE__ */ l.jsx(rt, { icon: "fa-regular fa-circle-info" }) }) })
      ]
    }
  ) });
}
const Ie = {
  INPUT: 0,
  DROPDOWN: 1,
  STATUS: 2
}, gs = ({
  columns: e,
  onSortClick: r,
  keyPrefix: t,
  rowHeight: s,
  responsiveStyles: i,
  hasRemoveColumn: n,
  className: c,
  showValidationStatus: o
}) => {
  const f = At(e), y = function(h) {
    f.update(h), r(h);
  };
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: "form-table-row-container",
      style: { height: s },
      role: "row",
      children: [
        e.map((h, g) => {
          if (h.type == Ie.STATUS && !o)
            return;
          const _ = h.type == Ie.STATUS;
          return /* @__PURE__ */ l.jsx(
            "div",
            {
              className: O(
                `form-table-header-cell-container-${h.id}`,
                c,
                "form-table-cell-container-main",
                _ && "status-cell-container"
              ),
              children: /* @__PURE__ */ l.jsx(
                ur,
                {
                  column: h,
                  onSortClick: y,
                  sortDirection: f.stateColumns.sortDirectionsMap.get(
                    h.id
                  ),
                  className: O(
                    `form-table-header-cell-${h.id}`,
                    c,
                    "form-table-header form-table-cell-main"
                  )
                },
                t + h.id
              )
            },
            t + "container" + h.id
          );
        }),
        i["large-panel"] && n && /* @__PURE__ */ l.jsx("div", { children: " " }, t + "actionmenu")
      ]
    }
  );
}, ys = ({
  id: e,
  value: r,
  className: t,
  type: s,
  name: i,
  errors: n,
  ref: c,
  required: o,
  onBlur: f,
  onChange: y,
  notification: h,
  label: g,
  locked: _,
  ...$
}) => {
  const [L, q] = ae(!!r), B = xe();
  Bt(c, () => B.current);
  const M = (w) => {
    const { current: T } = B;
    T.type = w ? "text" : "password";
  };
  return /* @__PURE__ */ l.jsxs("div", { className: O(t, "input-cell"), children: [
    /* @__PURE__ */ l.jsx(
      "input",
      {
        id: e,
        type: s,
        name: i,
        className: O(
          "custom-input",
          L && "has-content",
          n && "has-error"
        ),
        ref: B,
        required: o,
        onBlur: (w) => {
          var T;
          f && f(w), q(((T = w.target) == null ? void 0 : T.value) != "");
        },
        onChange: y,
        value: r,
        ...$,
        "aria-describedby": h
      }
    ),
    s == "password" && /* @__PURE__ */ l.jsx(br, { onPasswordToggle: M }),
    _ && /* @__PURE__ */ l.jsx("div", { className: "block-icon", children: /* @__PURE__ */ l.jsx(rt, { icon: ["fa-solid", "lock"] }) })
  ] });
};
function xs({ errorStatus: e, className: r }) {
  const t = We(() => e ? Object.values(e).map((o) => o == null ? void 0 : o.message) : [], [JSON.stringify(e)]), s = t.length > 0, i = s ? ["fa-solid", "fa-triangle-exclamation"] : ["fa-solid", "fa-check"], n = /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(rt, { className: "icon", icon: i }),
    /* @__PURE__ */ l.jsx("p", { className: "error-count-text", children: t.length || "" })
  ] }), c = (o) => {
    const [f, y] = ae("error"), h = s ? t.map((g, _) => /* @__PURE__ */ l.jsxs("span", { children: [
      g,
      /* @__PURE__ */ l.jsx("br", {})
    ] }, _)) : "User is valid";
    return ne(() => {
      y(s ? "error" : "text");
    }, [s]), /* @__PURE__ */ l.jsx(
      jt,
      {
        className: O("overflow", s && "has-error"),
        theme: f,
        html: /* @__PURE__ */ l.jsx("div", { className: "overflow-body", children: h }),
        children: o
      },
      f
    );
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: O("form-status-cell", r, s && "has-error"),
      children: c(n)
    }
  );
}
const ms = ({ value: e, onChange: r, data: t, error: s, className: i }) => {
  const [n, c] = ae(""), [o, f] = ae([]), y = pr({
    data: t,
    searchKeys: ["name"]
  }), h = (g) => {
    c(g), f(y.queryData(g));
  };
  return ne(() => {
    t && f(y.updateData(t));
  }, [t]), /* @__PURE__ */ l.jsx("div", { className: O("dropdown-cell", i), children: /* @__PURE__ */ l.jsxs(
    vr,
    {
      className: "menu-dropdown",
      selected: e,
      onOptionSelected: r,
      children: [
        /* @__PURE__ */ l.jsx(_r, { placeholder: "", clearEnabled: !1, error: s, children: e == null ? void 0 : e.name }),
        /* @__PURE__ */ l.jsxs(
          Fr,
          {
            maxHeight: 400,
            defaultTop: "50px",
            ignoreScroll: !0,
            minHeight: 400,
            children: [
              /* @__PURE__ */ l.jsx(
                Cr,
                {
                  className: "menu-name-search",
                  value: n,
                  onChange: ({ target: g }) => h(g.value),
                  placeholder: "Search",
                  type: "text"
                }
              ),
              o == null ? void 0 : o.map((g) => /* @__PURE__ */ l.jsx(
                jr,
                {
                  value: g,
                  propName: "id",
                  className: "menu-dropdown-item",
                  children: /* @__PURE__ */ l.jsxs("div", { className: "menu-dropdown-item-info", children: [
                    /* @__PURE__ */ l.jsx("h3", { children: g.name }),
                    /* @__PURE__ */ l.jsx("span", { title: g.description, children: g.description })
                  ] })
                },
                g.id
              ))
            ]
          }
        )
      ]
    }
  ) });
}, bs = ({
  rowData: e,
  rowIndex: r,
  columns: t,
  keyPrefix: s = "test",
  hasSelectionColumn: i = !1,
  className: n = "",
  isFirst: c = !1,
  responsiveStyles: o = {},
  hasRemoveColumn: f,
  removeRow: y
}) => {
  const { control: h } = He();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    t.map((g, _) => {
      var T, D, m;
      const $ = `${s}-${g.id}-${r}`;
      O(
        n,
        _ === (i ? 1 : 0) ? "form-table-cell-first" : "form-table-cell",
        `form-table-cell-${g.id}`
      );
      let B;
      const M = (T = g.options) == null ? void 0 : T.validation, w = (D = g.options) == null ? void 0 : D.isSecured;
      if (g.type === Ie.INPUT)
        B = /* @__PURE__ */ l.jsx(
          kt,
          {
            control: h,
            name: `formData[${r}].${g.id}`,
            rules: M,
            render: ({
              field: { onChange: C, onBlur: F, value: x },
              fieldState: { error: H }
            }) => /* @__PURE__ */ l.jsx("div", { className: "form-table-input-row", children: /* @__PURE__ */ l.jsx(
              ys,
              {
                className: "form-table-input",
                label: g.label,
                onChange: C,
                onBlur: F,
                value: x,
                errors: H,
                type: w ? "password" : "text"
              }
            ) })
          },
          $
        );
      else if (g.type === Ie.DROPDOWN) {
        const C = (m = g.options) == null ? void 0 : m.data;
        B = /* @__PURE__ */ l.jsx(
          kt,
          {
            control: h,
            rules: {
              ...M,
              validate: (F) => C.some(
                (H) => H.id === (F == null ? void 0 : F.id)
              ) || "Selected option is invalid"
            },
            name: `formData[${r}].${g.id}`,
            render: ({
              field: { value: F, onChange: x },
              fieldState: { error: H }
            }) => /* @__PURE__ */ l.jsx(
              ms,
              {
                value: F,
                onChange: x,
                data: C,
                error: H,
                className: n
              }
            )
          }
        );
      } else g.type == Ie.STATUS && (B = /* @__PURE__ */ l.jsx("div", { className: "form-table-status-row-cell", children: /* @__PURE__ */ l.jsx(xs, { errorStatus: e.status }) }));
      return /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: O(
            `form-table-cell-container-${g.id}`,
            c ? "form-table-cell-container-first" : "form-table-cell-container",
            n
          ),
          children: [
            !o["large-panel"] && /* @__PURE__ */ l.jsx(
              ur,
              {
                column: g,
                className: c ? "cell-level-header form-table-header-column-first" : "cell-level-header form-table-header-column"
              },
              "mobile" + g.id
            ),
            B
          ]
        },
        `${s}-container-${$}`
      );
    }),
    o["large-panel"] && f && /* @__PURE__ */ l.jsx("div", { className: "close-button-container", children: /* @__PURE__ */ l.jsx(
      De,
      {
        className: "close-button",
        icon: "fa-regular fa-times",
        onClick: () => y(r)
      }
    ) })
  ] });
};
function ps({
  fields: e,
  columns: r,
  responsiveStyles: t,
  rowHeight: s,
  hasRemoveColumn: i,
  className: n,
  remove: c
}) {
  const { formState: o } = He(), { errors: f } = o;
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: e.map((y, h) => {
    var _;
    const g = ((_ = f == null ? void 0 : f.formData) == null ? void 0 : _[h]) ?? null;
    return g && (y.status = g), /* @__PURE__ */ l.jsx(
      "div",
      {
        className: O("form-table-row-container"),
        role: "row",
        style: { height: s },
        children: /* @__PURE__ */ l.jsx(
          bs,
          {
            className: O("form-table-body-cell", n),
            rowData: y,
            rowIndex: h,
            columns: r,
            responsiveStyles: t,
            hasRemoveColumn: i,
            removeRow: c
          }
        )
      },
      y.id
    );
  }) });
}
function vs({
  bottomBarOptions: e,
  data: r,
  count: t,
  onCancel: s,
  isValid: i
}) {
  var o, f;
  const n = /* @__PURE__ */ l.jsxs("div", { className: "select-section", children: [
    /* @__PURE__ */ l.jsx(De, { onClick: s, children: "Cancel" }, "bottom-bar-button-cancel"),
    (o = e == null ? void 0 : e.left) == null ? void 0 : o.map((y, h) => /* @__PURE__ */ l.jsx(
      De,
      {
        destructive: y.destructive,
        icon: y.icon,
        primary: y.primary,
        onClick: () => {
          y.targetFunction(r);
        },
        children: y.text
      },
      `bottom-bar-button-${h}`
    ))
  ] }), c = /* @__PURE__ */ l.jsxs("div", { className: "action-section", children: [
    /* @__PURE__ */ l.jsxs(
      De,
      {
        primary: !0,
        type: "submit",
        disabled: !i || t === 0,
        children: [
          "Publish",
          /* @__PURE__ */ l.jsx("div", { className: "count-section", children: /* @__PURE__ */ l.jsx(Oe, { className: "select-count", count: t }) })
        ]
      },
      "bottom-bar-button-submit"
    ),
    (f = e == null ? void 0 : e.right) == null ? void 0 : f.map((y, h) => /* @__PURE__ */ l.jsxs(
      De,
      {
        destructive: y.destructive,
        icon: y.icon,
        primary: y.primary,
        onClick: () => {
          y.targetFunction(r);
        },
        children: [
          y.text,
          y.count && /* @__PURE__ */ l.jsx("div", { className: "count-section", children: /* @__PURE__ */ l.jsx(Oe, { className: "select-count", count: t }) })
        ]
      },
      `bottom-bar-button-${h}`
    ))
  ] });
  return /* @__PURE__ */ l.jsx(Kt, { leftSection: n, rightSection: c });
}
class dr {
  constructor({
    sortingEnabled: r,
    customFunction: t,
    propName: s,
    sortKeyFields: i,
    sortKeyFunctions: n,
    isFixed: c,
    width: o,
    validation: f,
    data: y,
    isSecured: h,
    hasInfo: g
  } = {}) {
    this.sortingEnabled = r, this.customFunction = t, this.propName = s, this.sortKeyFields = i, this.sortKeyFunctions = n, this.isFixed = c, this.width = o, this.validation = f, this.data = y, this.isSecured = h, this.hasInfo = g;
  }
}
class _s {
  constructor(r, t, s, i) {
    this.id = r, this.title = t, this.type = s, this.options = i ?? new dr(), this.propName = this.options.propName ?? r;
  }
}
const Fs = {
  STATUS: new _s(
    "status",
    "Status",
    Ie.STATUS,
    new dr({
      sortingEnabled: !0
    })
  )
}, Cs = { large: 70, medium: 180, small: 240 }, Ps = ({
  children: e,
  data: r = [],
  responsiveStyles: t,
  className: s,
  columns: i,
  showValidationStatus: n = !0,
  rowHeightConfig: c,
  virtualRowEnabled: o = !1,
  hasRemoveColumn: f = !0,
  bottomBarOptions: y,
  defaultSortPropName: h,
  defaultSortDirection: g,
  zeroStateMessage: _,
  onCancel: $,
  handleSubmitForm: L,
  showBottomBarOptions: q,
  rowToAdd: B,
  setRowToAdd: M
}) => {
  const w = xe(), T = xe(), D = {
    ...Cs,
    ...c
  }, [m, C] = ae([]), [F, x] = ae(!1), [H, U] = ae(!1), Y = hs({
    criteriaMode: "all",
    mode: "onChange",
    defaultValues: {
      formData: r
    }
  }), { handleSubmit: N, formState: E, trigger: k, control: P, reset: I, watch: Z } = Y, { isValid: he, errors: te } = E, Q = Z("formData"), { fields: ie, remove: _e, replace: Ne, append: Ee } = is({
    control: P,
    name: "formData"
  });
  ne(() => {
    B && (Ee(B), M()), k && k();
  }, [B, M, k]);
  const S = o ? Nt({
    parentRef: T,
    size: m == null ? void 0 : m.length,
    elementHeight: D.large
  }) : {};
  ne(() => {
    Q && Q.length !== ie.length && Ne(Q);
  }, [Q, Ne, ie.length]), ne(() => {
    const z = r && h ? Qe(
      r,
      Fe(),
      h,
      g
    ) : [...r];
    C(z), o && S.setSize(z.length);
  }, [JSON.stringify(r)]), ne(() => {
    if (!H && (te != null && te.formData) && (m != null && m.length)) {
      const z = G.ASCENDING;
      le(te, z), U(!0), F || x(!0);
    }
  }, [JSON.stringify(te), H, JSON.stringify(m)]), ne(() => {
    F && k && (k(), x(!1));
  }, [k, F]), ne(() => {
    I({
      formData: m
    }), F || x(!0);
  }, [JSON.stringify(m), I]);
  const le = (z, Ae) => {
    const Re = (ze) => {
      var Ue;
      return !!((Ue = z == null ? void 0 : z.formData) != null && Ue[ze]);
    };
    return [...Q].sort((ze, Ue) => {
      const at = Re(Q.indexOf(ze)), a = Re(Q.indexOf(Ue));
      return Ae === G.ASCENDING ? a - at : at - a;
    });
  }, oe = (z) => {
    let Ae;
    z.column.propName === "status" ? Ae = le(
      te,
      z.sortDirection || G.ASCENDING
    ) : Ae = Qe(
      Q,
      z.sortDirection === G.DEFAULT ? Fe() : z.column,
      h,
      z.sortDirection || g
    ), Ne(Ae);
  }, Fe = () => i == null ? void 0 : i.find(
    (z) => z.propName && z.propName == h
  ), Le = We(() => n ? [...i, Fs.STATUS] : i, [i, n]);
  ne(() => {
    o && (t["large-panel"] ? S.setVirtualRowHeight(D.large) : t["medium-panel"] ? S.setVirtualRowHeight(D.medium) : S.setVirtualRowHeight(D.small));
  }, [t]);
  const it = (z) => {
    L(z);
  };
  return !ie || (ie == null ? void 0 : ie.length) === 0 ? /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "form-table-container-v1",
      ref: T,
      style: {
        height: "auto",
        overflow: "auto"
      },
      role: "table",
      children: _
    }
  ) : /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "form-table-container-v1",
      ref: T,
      style: {
        height: S == null ? void 0 : S.viewportHeight,
        overflow: "auto"
      },
      role: "table",
      children: /* @__PURE__ */ l.jsx(Yr, { ...Y, children: /* @__PURE__ */ l.jsxs("form", { onSubmit: N(it), children: [
        ie && ie.length > 0 && /* @__PURE__ */ l.jsxs(
          "div",
          {
            ref: w,
            className: O("form-table", t, s),
            children: [
              o && /* @__PURE__ */ l.jsx("div", { style: { height: (S == null ? void 0 : S.topHeight) || 0 } }),
              (!o || (S == null ? void 0 : S.initialIndex) === 0 && t["large-panel"]) && /* @__PURE__ */ l.jsx(
                gs,
                {
                  columns: Le,
                  onSortClick: oe,
                  keyPrefix: "form",
                  className: "form-table-header-child",
                  responsiveStyles: t,
                  showValidationStatus: n,
                  rowHeight: S == null ? void 0 : S.virtualRowHeight,
                  hasRemoveColumn: f
                }
              ),
              /* @__PURE__ */ l.jsx(
                ps,
                {
                  fields: ie,
                  columns: Le,
                  responsiveStyles: t,
                  showValidationStatus: n,
                  initialIndex: S.initialIndex,
                  size: S.virtualRows,
                  rowHeight: S == null ? void 0 : S.virtualRowHeight,
                  hasRemoveColumn: f,
                  remove: _e
                }
              ),
              e,
              o && /* @__PURE__ */ l.jsx("div", { style: { height: (S == null ? void 0 : S.bottomHeight) || 0 } })
            ]
          }
        ),
        q && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
          vs,
          {
            onCancel: $,
            data: r,
            bottomBarOptions: y,
            count: ie == null ? void 0 : ie.length,
            isValid: he
          }
        ) })
      ] }) })
    }
  );
};
export {
  Rr as ActionBar,
  ve as BasicCell,
  Lr as Body,
  Tr as CheckboxCell,
  Bs as Column,
  Or as ColumnOptions,
  de as ColumnType,
  Br as DataTable,
  Ls as DecimalDataCell,
  Hs as Footer,
  ps as FormBody,
  _s as FormColumn,
  dr as FormColumnOptions,
  Ie as FormColumnType,
  gs as FormHeader,
  bs as FormRow,
  Ps as FormTable,
  Ye as HeaderColumn,
  ys as InputCell,
  Pe as MarkupCell,
  Us as PercentageDataCell,
  Hr as Row,
  Ot as SortButtons,
  G as SortDirection,
  Er as SortingState,
  xs as StatusCell,
  Os as Table,
  Gr as TableBody,
  Ms as TableCellListContent,
  Wr as TableHead,
  Pr as TableHeader,
  qr as TableRow,
  Rs as TimeDataCell,
  $s as UserCell,
  Is as getSortKeyFunctionForTableCellList,
  Ur as getSortMethod,
  Qe as handleSort,
  At as useSorting
};
